import type { CssVarsTheme } from '@mui/material';
import type { Components } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiIconButton']
>['styleOverrides'] = {
  root: ({ ownerState, theme }) => ({
    ...(ownerState.color === 'inherit' && {
      outline: `1px solid ${theme.vars.palette.grey[200]}`,
    }),
    ...(ownerState.color === 'default' && {
      outline: `1px solid ${theme.vars.palette.grey[200]}`,
    }),
    ...(ownerState.color &&
      ownerState.color !== 'inherit' &&
      ownerState.color !== 'default' &&
      ownerState.color && {
        outline: `1px solid ${theme.vars.palette[ownerState.color]?.light}`,
        '&:link': {
          outline: `1px solid ${theme.vars.palette[ownerState.color]?.light}`,
        },
        '&:hover': {
          outline: `1px solid ${theme.vars.palette[ownerState.color]?.main}`,
        },
        '&:active': {
          outline: `1px solid ${theme.vars.palette[ownerState.color]?.light}`,
        },
      }),
  }),
};

const MuiIconButton: Components<CssVarsTheme>['MuiIconButton'] = {
  styleOverrides,
};

export default MuiIconButton;
